import { PkCarousel, PkSpinner } from '@uefadigital/panenka-react';
import { memo } from 'react';

import { useRelatedPlayersFetcher } from './hooks';
import PlayerCard from './PlayerCard';
import type { RelatedPlayersOptions } from './types';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

const BREAKPOINTS = {
  0: {
    slidesPerView: 2.3,
    slidesPerGroup: 2,
    spaceBetween: 12,
  },
  768: {
    slidesPerView: 2.5,
    slidesPerGroup: 3,
    spaceBetween: 12,
  },
  1024: {
    slidesPerView: 3.4,
    slidesPerGroup: 4,
    spaceBetween: 12,
  },
  1200: {
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: 12,
  },
};

const RelatedPlayers = ({ options }: { options: RelatedPlayersOptions }) => {
  const { isLoading, players } = useRelatedPlayersFetcher(options);
  const t = useTranslateFn();

  if (!options.fieldPosition) return null;

  return (
    <div className={styles.carouselWrapper}>
      {isLoading ? (
        <div className={styles.loading}>
          <PkSpinner />
        </div>
      ) : (
        !!players.length && (
          <PkCarousel breakpoints={BREAKPOINTS}>
            <div slot='headline'>{t('related_players')}</div>
            {players.map((player) => (
              <PlayerCard key={player.id} player={player} />
            ))}
          </PkCarousel>
        )
      )}
    </div>
  );
};

export default memo(RelatedPlayers);
